// extracted by mini-css-extract-plugin
module.exports = {"faqList":"FAQList_faqList__VIAqJ","expanded":"FAQList_expanded__C1mUV"};